import utils from './utils';

/**
 *
 * @Usage:       $.fn.customSelectOverlay()
 *
 */

(function( $ ) {
    $.fn.customSelectOverlay = function() {
        const tryDisplayNotFound = function($listWrapper) {
            if (!$listWrapper.children('.custom-option:not(.hide)').length) {
                $listWrapper.find('.not-found').removeClass('hide');
            } else {
                $listWrapper.find('.not-found').addClass('hide');
            }
        };

        const markSelected = function($select) {
            let $holder = $select.parent('.j-select-holder');
            let $customOption = $holder.find('.j-custom-option-list');
            $customOption.find('.custom-option:not(.not-found)').each(function (_index, item) {
                if ($(item).attr('value') == $select.val()) {
                    $(item).addClass('is-selected');
                    $(item).addClass('is-focused');
                } else {
                    $(item).removeClass('is-selected');
                    $(item).removeClass('is-focused');
                }
            });
        };

        const updateOptionList = function($select, $listWrapper) {
            $listWrapper.children().remove();
            let $option = $('<div class="custom-option"></div>');
            $select.find('option').each(function (_index, item) {
                let $item = $(item);
                let $clone = $option.clone();
                $clone.text($item.text());
                $clone.attr('data-text', $item.text());
                $.each(item.attributes, function(_idx, attr) {
                    $clone.attr(attr.name, attr.value);
                });
                $listWrapper.append($clone);
                $clone.on('click', function() {
                    selectOption($select, $clone, $listWrapper);
                });
                $clone.on('mouseenter', function() {
                    $listWrapper.find('.custom-option.is-focused').removeClass('is-focused');
                    $clone.addClass('is-focused');
                });
            });
            $listWrapper.append('<div class="custom-option not-found hide">Not Found</div>');
            $options = $listWrapper.find('.custom-option');
            tryDisplayNotFound($listWrapper);
        };

        const selectOption = function($select, $option, _$listWrapper) {
            let $customOption = $select.parent('.j-select-holder').find('.j-custom-option-list');
            $customOption.addClass('hide');
            enableSelectPointerEvents($customOption);
            $select.val($option.attr('value'));
            $select.change();
        };

        const search = function(term, $listWrapper) {
            if (term) {
                $listWrapper.find('.custom-option').addClass('hide');
                let containValOptions = document.evaluate(`./*[contains(@class, "custom-option")][contains(translate(@value, "ABCDEFGHIJKLMNOPQRSTUVWXYZ","abcdefghijklmnopqrstuvwxyz"), "${term}")]`, $listWrapper[0], null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE);
                let startWithValOptions = document.evaluate(`./*[contains(@class, "custom-option")][starts-with(translate(@value, "ABCDEFGHIJKLMNOPQRSTUVWXYZ","abcdefghijklmnopqrstuvwxyz"), "${term}")]`, $listWrapper[0], null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE);
                let containTextOptions = document.evaluate(`./*[contains(@class, "custom-option")][contains(translate(@data-text, "ABCDEFGHIJKLMNOPQRSTUVWXYZ","abcdefghijklmnopqrstuvwxyz"), "${term}")]`, $listWrapper[0], null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE);
                let startWithTextOptions = document.evaluate(`./*[contains(@class, "custom-option")][starts-with(translate(@data-text, "ABCDEFGHIJKLMNOPQRSTUVWXYZ","abcdefghijklmnopqrstuvwxyz"), "${term}")]`, $listWrapper[0], null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE);

                for (let i = 0; i < containValOptions.snapshotLength; i++) {
                    let $el = $(containValOptions.snapshotItem(i));
                    $el.removeClass('hide');
                    $listWrapper.prepend($el);
                }
                for (let i = 0; i < startWithValOptions.snapshotLength; i++) {
                    let $el = $(startWithValOptions.snapshotItem(i));
                    $listWrapper.prepend($el);
                }
                for (let i = 0; i < containTextOptions.snapshotLength; i++) {
                    let $el = $(containTextOptions.snapshotItem(i));
                    $el.removeClass('hide');
                    $listWrapper.prepend($el);
                }
                for (let i = 0; i < startWithTextOptions.snapshotLength; i++) {
                    let $el = $(startWithTextOptions.snapshotItem(i));
                    $listWrapper.prepend($el);
                }
            } else {
                if ($options) {
                    $listWrapper.append($options);
                }
                $listWrapper.find('.custom-option.hide').removeClass('hide');
            }
            let $selected = $listWrapper.find('.custom-option.is-selected:not(.not-found):not(.hide)');
            if ($selected.length) {
                utils.scrollFocusOnElement($listWrapper, $selected);
            } else {
                let $focused = $listWrapper.find('.custom-option.is-focused:not(.not-found):not(.hide)');
                if (!$focused.length) {
                    $focused = $($listWrapper.find('.custom-option:not(.not-found):not(.hide)')[0]);
                }
                $listWrapper.find('.custom-option.is-focused').removeClass('is-focused');
                $focused.addClass('is-focused');
                utils.scrollFocusOnElement($listWrapper, $focused);
            }
            tryDisplayNotFound($listWrapper);
        };

        const toggleDropdown = function(e, $select) {
            e.preventDefault();
            let $holder = $select.parent('.j-select-holder');
            let $customOption = $holder.find('.j-custom-option-list');
            let $searchInput = $customOption.find('.custom-option-list-search');
            if ($customOption.hasClass('hide')) {
                $searchInput.val('');
                $searchInput.trigger('keyup');
                $customOption.removeClass('hide');
                $searchInput.focus();

                $customOption.find('.custom-option.is-focused').removeClass('is-focused');
                let $selected = $customOption.find('.custom-option.is-selected');
                $selected.addClass('is-focused');
                if ($selected.length) {
                    let $listWrapper = $customOption.find('.custom-option-wrapper');
                    let pos = $selected.offset().top - $listWrapper.offset().top + $listWrapper.scrollTop();
                    $listWrapper.scrollTop(pos);
                }
                disableSelectPointerEvents($customOption);
            } else {
                $customOption.addClass('hide');
                enableSelectPointerEvents($customOption);
            }
        };

        const enableSelectPointerEvents = function($select) {
            let $holder = $select.parent();
            $holder.closest('form').find('.j-select-holder').not($holder).css({
                'pointer-events': 'auto'
            });
        };

        const disableSelectPointerEvents = function($select) {
            let $holder = $select.parent();
            $holder.closest('form').find('.j-select-holder').not($holder).css({
                'pointer-events': 'none'
            });
        };

        let $options;

        $(this).each(function(_index, item) {
            let $this = $(item);
            $this.selectOverlap();

            // config
            let enableSearch = $this.attr('data-enable-search') == 'false' ? false : true;

            let $customOption = $('<div class="j-custom-option-list custom-option-list hide"></div>');
            let baseClassName = $this.attr('name');
            let cssClass = 'custom-option-list-' + baseClassName;
            let jsClass = 'j-' + cssClass;
            $customOption.addClass(cssClass);
            $customOption.addClass(jsClass);

            let $searchInput = $(`<input type="${enableSearch ? 'text' : 'hidden'}" class="custom-option-list-search" placeholder="${utils.translate('search')}...">`);
            $customOption.append($searchInput);

            let $optionList = $('<div class="custom-option-wrapper"></div>');
            $customOption.append($optionList);
            updateOptionList($this, $optionList);

            let $selectOverlay = $($this.parents('.j-select-holder')[0]);
            $selectOverlay.append($customOption);

            $searchInput.on('keyup', utils.debounce(function(e) {
                if (e.which == 38 || e.which == 40 || e.which == 9) {
                    return;
                }
                search($searchInput.val().trim().toLowerCase(), $optionList);
            }, 500));
            
            $this.on('customSelect:updateOptionList', function(){
                updateOptionList($this, $optionList);
            });

            $this.on('mousedown', function(e) {
                toggleDropdown(e, $this);
            });

            $this.on('change', function() {
                markSelected($this);
            });
            
            $this.closest('form').on('keydown', function(e) {
                let $target = $(e.target);
                if ($selectOverlay.has($target).length && (e.which == 32 || e.which == 38 || e.which == 40) && $customOption.hasClass('hide')) {
                    e.preventDefault();
                    $this.trigger('mousedown');
                }
            });

            $searchInput.on('keydown', function(e) {
                let $focused = $customOption.find('.custom-option.is-focused:not(.not-found):not(.hide)');
                let $target;
                if ($focused.length) {
                    if (e.which == 38) { // key up
                        $target = $($focused.prevAll('.custom-option:not(.hide)')[0]);
                        if (!$target.length) {
                            let $available = $customOption.find('.custom-option:not(.not-found):not(.hide)');
                            $target = $($available[$available.length-1]);
                        }
                        if ($target.length) {
                            $customOption.find('.custom-option.is-focused').removeClass('is-focused');
                            $target.addClass('is-focused');
                            utils.scrollFocusOnElement($optionList, $target);
                        }
                    }
                    
                    if (e.which == 9) {
                        e.preventDefault();
                    }
                    if (e.which == 40 || e.which == 9) { // key down or tab
                        $target = $($focused.nextAll('.custom-option:not(.hide)')[0]);
                        if (!$target.length) {
                            $target = $($customOption.find('.custom-option:not(.not-found):not(.hide)')[0]);
                        }
                        if ($target.length) {
                            $customOption.find('.custom-option.is-focused').removeClass('is-focused');
                            $target.addClass('is-focused');
                            utils.scrollFocusOnElement($optionList, $target);
                        }
                    }
    
                    if (e.which == 13) { // enter
                        $focused.click();
                    }
                } else {
                    if (e.which == 38 || e.which == 40 || e.which == 9) {
                        $target = $($customOption.find('.custom-option:not(.not-found):not(.hide)')[0]);
                        if ($target.length) {
                            $target.addClass('is-focused');
                            utils.scrollFocusOnElement($optionList, $target);
                        }
                    }
                }


                if (e.which == 27) { // esc
                    $customOption.addClass('hide');
                    enableSelectPointerEvents($this);
                }
            });

            $(document).on('click', function(e) {
                let $target = $(e.target);
                if (!$selectOverlay.has($target).length) {
                    $customOption.addClass('hide');
                    enableSelectPointerEvents($this);
                }
            });

            markSelected($this);
        });
    };
})(jQuery);

